import clsx from "clsx";
import GradientBorderRadius from "./gradient-border-radius";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/16/solid";

type ExpandHeightButtonProps = {
  expanded: boolean;
  toggleExpanded: () => void;
  className?: string;
};

const ExpandHeightButton = ({
  expanded,
  toggleExpanded,
  className,
}: ExpandHeightButtonProps) => {
  return (
    <button onClick={toggleExpanded}>
      <GradientBorderRadius
        gradient="default-border"
        hover="r-100"
        radius="circle"
        className={clsx("w-[1.375rem] h-[1.375rem]", className)}
      >
        <div className="flex justify-center items-center pt-[0.05rem] pl-[0.05rem]">
          {expanded ? <ChevronDownIcon /> : <ChevronUpIcon />}
        </div>
      </GradientBorderRadius>
    </button>
  );
};

export default ExpandHeightButton;
